/**
 * MSW Overrides: Booking Detail Quota scenario
 *
 * Returns the real booking detail response but with `quota` injected at
 * the top level of the response (alongside `id`, `bookingStatus`, etc.).
 * These represent the subscription credit breakdown shown on the trip
 * detail page for a previously-confirmed booking.
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_BOOKING_DETAIL_QUOTA=true
 * in your .env, then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse, bypass } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { BookingListQuota, BookingResponse } from '@cvo/domain';

export const MOCK_BOOKING_DETAIL_QUOTA: BookingListQuota = {
  consumed: 3,
  availableBefore: 10,
  availableAfter: 7,
};

export function createBookingDetailQuotaOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING)}`,
      async ({ request }) => {
        const originalResponse = await fetch(bypass(request));
        const data: BookingResponse = await originalResponse.json();

        const result = {
          ...data,
          quota: MOCK_BOOKING_DETAIL_QUOTA,
        };

        console.log('[MSW] booking detail quota injected:', result.quota);

        return HttpResponse.json(result);
      },
    ),
  ];
}
